<template>
  <div class="container push-top">
    <div class="columns">
      <div class="column is-12">
        <h2 class="is-pulled-left">{{ $t('navigation.activity') }}</h2>
        <form class="propsal-filter is-pulled-right">
          <span class="filter-by">{{ $t('filters.filter_by') }} </span>
          <multiselect v-model="filterDocument" :options="filterDocumentOptions" :placeholder="$t('filters.proposal_filter_options.all_proposals')"
            track-by="id" label="title" :showLabels="false"></multiselect>
          <multiselect v-model="filterActions" :options="filterActionsOptions" :placeholder="$t('filters.action_filter_options.all_actions')"
            track-by="value" label="label" :showLabels="false"></multiselect>
          <multiselect v-model="filterTeamMember" :options="filterTeamMemberOptions" :placeholder="$t('filters.team_filter_options.everyone')"
            track-by="id" label="name" :showLabels="false"></multiselect>
        </form>
      </div>
    </div>
    <div class="no-activity" v-if="activities !== false && activities.length <= 0 && pagination.currentPage === 0">
      <img src="/images/sad.png">
      <h3>{{ $t('activity.no_activity_msg_title') }}</h3>
      <p>{{ $t('activity.no_activity_msg_body') }}</p>
    </div>
    <div class="columns">
      <div class="column is-12">
        <div class="activity-wrapper">
          <transition enter-active-class="animated fadeIn">
            <div class="activity-date" v-if="activities !== false && activities.length > 0 && activitiesToday.length > 0">
              <hr>
              <h3>{{ $t('activity.today') }}</h3>
              <ul>
                <activity-line-item :activity="activity" v-for="activity in activitiesToday" :key="activity.id"></activity-line-item>
              </ul>
            </div>
          </transition>
          <transition enter-active-class="animated fadeIn">
            <div class="activity-date" v-if="activities !== false && activities.length > 0 && activitiesYesterday.length > 0">
              <hr>
              <h3>{{ $t('activity.yesterday') }}</h3>
              <ul>
                <activity-line-item :activity="activity" v-for="activity in activitiesYesterday" :key="activity.id"></activity-line-item>
              </ul>
            </div>
          </transition>
          <transition enter-active-class="animated fadeIn">
            <div class="activity-date" v-if="activities !== false && activities.length > 0 && activitiesAllTime.length > 0">
              <hr>
              <h3>{{ $t('activity.all_time') }}</h3>
              <ul>
                <activity-line-item :activity="activity" v-for="activity in activitiesAllTime" :key="activity.id"></activity-line-item>
              </ul>
            </div>
          </transition>
          <loading-indicator v-if="showInfiniteLoadingIndicator"></loading-indicator>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import API from 'mixins/api';
import ActivityLineItem from './partials/activity-line-item.vue';

export default {
  mixins: [API],
  props: ['currentTeam'],
  components: {
    ActivityLineItem,
  },
  data() {
    return {
      pagination: {
        perPage: 10,
        currentPage: null,
        from: null,
        lastPage: null,
        to: null,
        total: null,
        filters: {
          action: null,
          document_id: null,
          subject_type: null,
          subject_id: null,
        }
      },
      activities: false,
      documents: [],
      filterActionsOptions: [],
      filterDocument: false,
      filterDocumentOptions: [],
      filterActions: false,
      filterTeamMemberOptions: [],
      filterTeamMember: false,
      showInfiniteLoadingIndicator: false
    }
  },
  beforeMount() {
    this.filterTeamMemberOptions = _.clone(this.currentTeam.users);
    this.filterTeamMemberOptions.unshift({
      name: this.$t('filters.team_filter_options.everyone'),
      value: null
    });
    this.filterActionsOptions = [{
      label: this.$t('filters.action_filter_options.all_actions'),
      value: null
    }, {
      label: this.$t('filters.action_filter_options.created'),
      value: 'Created'
    }, {
      label: this.$t('filters.action_filter_options.edited'),
      value: 'Edited'
    }, {
      label: this.$t('filters.action_filter_options.deleted'),
      value: 'Deleted'
    }, ];

    this.api().fetchTeamDocuments().then(documents => {
      this.documents = documents;
      this.filterDocumentOptions = this.documents;
      this.filterDocumentOptions.unshift({
        title: this.$t('filters.proposal_filter_options.all_proposals'),
        value: null
      });
    });
  },
  mounted() {
    // Trigger first page
    this.$set(this.pagination, 'currentPage', 1);
    window.addEventListener('scroll', this.checkInfiniteScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.checkInfiniteScroll);
  },
  methods: {
    getActivities() {
      this.showInfiniteLoadingIndicator = true;

      this.pagination.filters = {};

      if (this.filterDocument && this.filterDocument.value !== null) {
        this.pagination.filters.document_id = this.filterDocument.id;
      }

      if (this.filterActions && this.filterActions.value !== null) {
        this.pagination.filters.action = this.filterActions.value;
      }

      if (this.filterTeamMember && this.filterTeamMember.value !== null) {
        this.pagination.filters.subject_type = 'App\\User';
        this.pagination.filters.subject_id = this.filterTeamMember.id;
      }

      this.pagination.filters.per_page = this.pagination.perPage;

      this.api().fetchTeamActivities(this.pagination.currentPage, this.pagination.filters)
        .then(payload => {
          this.activities = this.activities || [];
          this.pagination.from = payload.from;
          this.pagination.lastPage = payload.last_page;
          this.pagination.to = payload.to;
          this.pagination.total = payload.total;

          this.activities = this.activities.concat(payload.data);
          this.showInfiniteLoadingIndicator = false;
        });
    },
    checkInfiniteScroll() {
      if (this.pagination.lastPage <= this.pagination.currentPage) {
        return;
      }
      const activityWrapper = document.getElementsByClassName(
        'activity-wrapper')[0];

      let dist = activityWrapper.offsetHeight + activityWrapper.getBoundingClientRect()
        .top;

      if (dist <= window.innerHeight && !this.showInfiniteLoadingIndicator) {
        this.pagination.currentPage += 1;
      }
    },
    resetFilters() {
      this.pagination.currentPage = 1;
      this.activities = [];
      this.getActivities();
    }
  },
  computed: {
    activitiesToday() {
      const startDate = (new Date()).setDate((new Date()).getDate() - 1);

      return _.filter(this.activities,
        activity => (new Date(activity.created_at)) >= startDate
      );
    },
    activitiesYesterday() {
      const startDate = (new Date()).setDate((new Date()).getDate() - 2);
      const endDate = (new Date()).setDate((new Date()).getDate() - 1);
      return _.filter(this.activities,
        activity => (new Date(activity.created_at)) >= startDate && (new Date(
          activity.created_at)) <= endDate
      );
    },
    activitiesAllTime() {
      const endDate = (new Date()).setDate((new Date()).getDate() - 2);
      return _.filter(this.activities,
        activity => (new Date(activity.created_at)) <= endDate
      );
    }
  },
  watch: {
    'pagination.currentPage' () {
      this.getActivities();
    },
    filterActions() { this.resetFilters(); },
    filterDocument() { this.resetFilters(); },
    filterTeamMember() { this.resetFilters(); },
  }
}
</script>

<style lang="scss" scoped>
@import "resources/assets/sass/layout/_variables";
.multiselect {
  width: 170px;
  margin-left: 10px;
}

.no-activity {
  width: 400px;
  background: $white;
  text-align: center;
  padding: 40px;
  border-radius: 5px;
  display: block;
  margin: 200px auto;
  border: 1px solid lighten($mutedblue, 12%);
  img {
    width: 60px;
    display: block;
    margin: 0 auto 26px;
  }
  h3 {
    font-size: 16px;
    text-transform: uppercase;
    font-weight: 600;
    margin: 0 0 20px;
    letter-spacing: 1px;
  }
  p {
    margin-bottom: 25px;
  }
}

.activity-date {
  h3 {
    display: block;
    margin: -32px auto 30px;
    text-transform: uppercase;
    letter-spacing: 1px;
    font-weight: 700;
    padding: 0 20px;
    text-align: center;
    max-width: 160px;
    background: darken($eggshell, 2%);
  }
  ul {
    margin: 20px 0 40px;
  }
}
</style>



// WEBPACK FOOTER //
// Activity.vue?58992c23